(ns frontend.ui.component.dynamic-table.cell.style
  (:require
   [frontend.ui.style.theme.core :as theme]
   [herb.core :refer [<class]]))


(defn default
  []
  {:text-align       :right
   :padding          "0.75rem 0.5rem"
   :background-color :inherit})

(defn row-heading
  []
  ^{:extend default}
  {:font-weight    :bold
   :text-transform :uppercase
   :position       :sticky
   :text-align     :left
   :left           0})

(defn bold
  []
  ^{:extend default}
  {:font-weight :bold})

(defn number
  []
  ^{:extend default}
  {:text-align  "right"
   :white-space "nowrap"})

(defn bold-number
  []
  ^{:extend [[default] [bold] [number]]}
  {})

(defn class
  [data row-style cell-style data-type]
  (let [bold? (or (-> row-style
                      :bold?)
                  (-> cell-style
                      :bold?))
        data-format-string (-> cell-style
                               :data-format-string)
        style-fn (cond
                   (and bold? (number? data))
                   bold-number

                   bold?
                   bold

                   (number? data)
                   number

                   :else
                   default)]
    (<class style-fn)))
